import { rem } from 'polished';
import styled from 'styled-components/macro';

export const StyledParagraph = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-size: ${rem('16px')};
  font-weight: 400;

  &:not(:first-child) {
    margin-top: ${rem('8px')};
  }

  &:not(:last-child) {
    margin-bottom: ${rem('8px')};
  }
`;

export const StyledH1 = styled.h1`
  margin: 0;
  color: ${({ theme }) => theme.colors.main};
  font-size: ${rem('30px')};
  font-weight: 700;
  line-height: 1.17;
`;

export const StyledH2 = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${rem('26px')};
  font-weight: 700;
  line-height: 1.2;
`;

export const StyledH3 = styled.h3`
  margin: 0;
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${rem('18px')};
  font-weight: 600;
  line-height: 1.4;
`;
